/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import {defineMessages} from 'react-intl'
import {Account, HeartIcon, OrderIcon, RewardsIcon} from '../../components/icons'

export const messages = defineMessages({
    profile: {defaultMessage: 'My Account', id: 'global.account.link.account_details'},
    rewards: {defaultMessage: 'My Rewards', id: 'global.account.link.rewards'},
    orders: {defaultMessage: 'Orders', id: 'global.account.link.order_history'},
    wishlist: {defaultMessage: 'Wishlist', id: 'global.account.link.wishlist'}
})

export const statusLevels = [
    {
        key: 'creator',
        message: {
            id: 'account_modal.status.creator',
            defaultMessage: 'Creator'
        }
    },
    {
        key: 'muse',
        message: {
            id: 'account_modal.status.muse',
            defaultMessage: 'Muse'
        }
    },
    {
        key: 'icon',
        message: {
            id: 'account_modal.status.icon',
            defaultMessage: 'Icon'
        }
    }
]

export const navLinks = [
    {
        name: 'profile',
        path: '',
        icon: Account
    },
    {
        name: 'rewards',
        path: '/my-rewards',
        icon: RewardsIcon
    },
    {
        name: 'wishlist',
        path: '/wishlist',
        icon: HeartIcon
    },
    {
        name: 'orders',
        path: '/orders',
        icon: OrderIcon
    }
]
